import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Row from "./Row";
import Label from "../../../../../components/Label";
import { TransactionDetails } from "../../../types";
import CardText from "../../CardText";

type Props = {
  discountInfo: TransactionDetails["payment"]["discountInfo"];
};

export default function DiscountInfo({ discountInfo }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  if (!discountInfo) {
    return null;
  }

  const { code, percentage, amount, currency } = discountInfo;

  const percent = `-${percentage}%`;
  const discountAmount = amountAsCurrency({ amount, currency });

  return (
    <View style={tailwind("mt-4")}>
      <CardText.Title text="Descuento" />
      <Row>
        <View style={tailwind("flex-row items-center mt-1")}>
          <Label
            name={code.toUpperCase()}
            backgroundColor={colors.surfaceVariant}
            textColor={colors.onSurfaceVariant}
          />
          <Text style={tailwind("ml-1")}>{percent}</Text>
        </View>
        <Text>{discountAmount}</Text>
      </Row>
    </View>
  );
}
